<template>
  <v-container grid-list-md class="bookmark-card-container" :class="{'px-0': $vuetify.breakpoint.smAndDown}" v-if="bookmarks">
      
        <div class="flex xs12 section-header">{{ bookmarks.title }}</div>

        <section class="card-list opacity-0 no-scrollbar lozad">
          <div 
              v-for="(item, idx) in bookmarks.bookmark"
              :key="idx"
          >
            <v-card :id=item.className :class="['card bookmark-card item ma-2', item.className]"  :elevation="2" :href="item.url" target="_blank" rel="noopener noreferrer">
                <div class="card-thumb-container">
                    <v-img
                    class="card-thumb"
                    :src="item.thumbnail"
                    contain
                    />
                </div>
                <v-card-title class="pa-0">
                    <v-flex text-xs-left class="card-title">
                        <div class="card-title">{{item.name}}</div>
                    </v-flex>
                </v-card-title>
            </v-card>
          </div>
        </section>
   </v-container>
</template>

<script>
import lozad from 'lozad'

export default {
  name: 'Bookmarks',
  props: {
    bookmarks: {
      type: Object,
      default: () => ({ title: '', bookmark: [] })
    }
  },
  data () {
    return {
      show: false,
      loading: false,
      noData: false
    }
  },
  methods: {
    loadImages () {
      const observer = lozad('.lozad', {
          rootMargin: '100px 0px', // like css margin
          // threshold: 0.1 // ratio of element convergence
          loaded: function(el) {
              // Custom implementation on a loaded element
              el.classList.add('loaded');
              // el.classList.remove('loading-blur');
          }
      });

      observer.observe();
    }
  },
  mounted () {
    this.loadImages()
  },
  computed: {
    flex () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 12
        case 'sm': return 6
        case 'md': return 4
        case 'lg': return 3
        case 'xl': return 3
        default: return 3
      }
    }
  }
}

</script>

<style lang="scss" scoped>
    .bookmark-card-container {
        .card-list {
            grid-auto-columns: auto;
        }

        .bookmark-card {
            width: 125px;
            height: 105px;

            .card-thumb-container {
                height: 75px;
                background-color: #ddd;

                .card-thumb {
                    height: 65px;
                    width: 110px;
                    margin: 0 auto;
                    position: relative;
                    top: 4px;
                }
            }

            .card-title {
              font-size: .875rem;
              font-weight: 400;
              text-align: center;
            }
        }
    }
</style>

<style lang="scss">
  .bookmark-card-container {

    #autotrader {
      .card-thumb-container {
        background-color: #012169;
      }
    }

    #awwwards {
      .v-image__image.v-image__image--contain {
        background-size: cover;
      }
    }

    #bestwebsitegallery {
      .card-thumb-container {
        background: url('http://launcher.evanyamoto.com/img/bestwebsitegallery.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }

    #bleacherreport {
      .card-thumb-container {
        background: url('http://launcher.evanyamoto.com/img/bleacherreport.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }

    #bring-a-trailer {
      .card-thumb-container {
        background-color: #000;
      }
    }

    #cssnectar {
      .card-thumb-container {
        background: url('http://launcher.evanyamoto.com/img/cssnectar.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }

    #dribbble {
      .card-thumb-container {
        background-color: #333;
      }
    }

    #espn {
      .card-thumb-container {
        background-color: #d00;
      }
    }

    #figma {
      .card-thumb-container {
        background: url('http://launcher.evanyamoto.com/img/figma.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }

    #muzli {
      .card-thumb-container {
        background-color: #F42A79;
      }
    }

    #phillips {
      .card-thumb-container {
        background-color: #0f0f0f;
      }
    }
    
    #reignoftroy {
      .card-thumb-container {
        background: url('http://launcher.evanyamoto.com/img/reignoftroy.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
      }
    }

    #refactoringui {
      .card-thumb-container {
        background: url('http://launcher.evanyamoto.com/img/refactoringui.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
      }
    }

    #rennlist {
      .card-thumb-container {
        background-color: #36576f;
      }
    }

    #smashing {
      .card-thumb-container {
        background-color: #d33a2c;
      }
    } 

    #uscfootball {
      .card-thumb-container {
        background-color: #600;
      }
    }

    #uxbooth {
      .card-thumb-container {
        background: url('http://launcher.evanyamoto.com/img/uxbooth.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }

    #uxcollective {
      .card-thumb-container {
        background-color: #0cf;
      }
    }

    #yahoosports {
      .card-thumb-container {
        background-color: #2d1152;
      }
    }

    #wearesc {
      .card-thumb-container {
        background-color: #970f07;
      }
    }

    #whimsical {
      .card-thumb-container {
        background-color: #aa24eb;
      }
    }
    
  }

</style>
